import React from "react";
import { iconFor } from "../layouts/techIcons";
import { companiesData, marqueeTech } from "../../constants";

const TechStrip = () => {
  return (
    <section className="sectionWrap !py-14 flex flex-col gap-10">
      <div className="flex flex-col items-center gap-5">
        <p className="text-xs uppercase tracking-[4px] text-gray-500">Where I've delivered</p>
        <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-4">
          {companiesData.map(({ name, note }) => (
            <span
              key={name}
              className="font-titleFont text-xl md:text-2xl font-bold text-gray-500 hover:text-white duration-300"
            >
              {name}
              {note && <span className="ml-2 text-xs font-normal text-gray-600 align-middle">{note}</span>}
            </span>
          ))}
        </div>
      </div>
      <div className="marqueeMask overflow-hidden">
        <div className="marquee flex w-max gap-4">
          {[...marqueeTech, ...marqueeTech].map((name, i) => (
            <span
              key={`${name}-${i}`}
              aria-hidden={i >= marqueeTech.length}
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-black/25 border border-white/5 text-gray-400 whitespace-nowrap"
            >
              <span className="text-designColor text-lg">{iconFor(name)}</span>
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStrip;
